import togetherLogoImg from '../assets/logo_trans.png';
// import defaultBackgroundImg from '../assets/background_temple.png';
import defaultLogoimage from '../assets/logo_blu.png';
import defaultBackgroundImg from '../assets/background_clg.jpg';

export const versionNum = 'V.1.2.4.6';

export const togetherLogo = {
  logo: togetherLogoImg,
};

export const primaryBlue = '#3949AB';

export const defaultImages = {
  background: defaultBackgroundImg, //background is being used in event landing pages (view event and similar)
  logo: defaultLogoimage, //this is eventlogo (eventIcon)
};

export const layoutImgDims = {
  //layouId : [array of image dimensions]
  1: { height: '415px', width: '624px' },
  2: { height: '687px', width: '1080px' },
  3: { height: '786px', width: '1080px' },
  4: { height: '720px', width: '1080px' },
  5: { height: '786px', width: '1080px' },
  // 6: { height: '720px', width: '1080px' },
  6: { height: '595px', width: '1080px' },
  7: { height: '595px', width: '827px' },
};

//Manage session and local storage

export const setUserBrowserStorage = (itemName, itemValue) => {
  localStorage.setItem(itemName, itemValue);
};

export const getUserBrowserStorage = (itemName) => {
  return localStorage.getItem(itemName);
};

export const clearAllBrowserStorage = () => {
  localStorage.clear();
};

export const setSessionItem = (itemName, itemValue) => {
  sessionStorage.setItem(itemName, itemValue);
};

export const getSessionItem = (itemName) => {
  return sessionStorage.getItem(itemName);
};

export const removeSessionItem = (itemName) => {
  sessionStorage.removeItem(itemName);
};

//Manage Password validation
export const passwordHelper = 'Password must be at least 9 characters';

export const checkPassword = (str) => {
  const remSpace = str.trim();
  var re = /.{9,}/;
  return re.test(remSpace);
};

export const popoverZIndex = 1301;

export const resendTimerOTP = 30;

// export const roomParticipantsListName = "room_participants";
// export const eventParticipantsListName = "event_participants";
// export const cancelledEventStatus = "cancelled";

export const monthArray = {
  1: 'JAN',
  2: 'FEB',
  3: 'MAR',
  4: 'APR',
  5: 'MAY',
  6: 'JUN',
  7: 'JUL',
  8: 'AUG',
  9: 'SEP',
  10: 'OCT',
  11: 'NOV',
  12: 'DEC',
};
export const succDuration = 6000; //success toaster duration
export const errDuration = 8000; //error toaster duration

export const roomParticipantsListName = 'room_participants';
export const eventParticipantsListName = 'event_participants';

export const cancelledEventStatus = 'cancelled';

export const watchAsGuestTermsText =
  "By clicking on join you are accepting 2Gather's";
export const signUpTermsText = "I accept 2Gather's";
export const signInTermsText = "By signing in you are accepting 2Gather's";
